export const options = [
  {
    label: 'API documentation',
    href: '#'
  },
  {
    label: 'SDKs',
    href: '#'
  },
  {
    label: 'Tools for integration',
    href: '#'
  }
]